import { I18n } from 'aws-amplify/utils';
import { useParams } from 'react-router-dom';
import { useTags } from '../../tags/hooks/useTags';
import { config } from '../config';

export const useIndexPageHeader = () => {
    const { status, tag: tagId } = useParams();
    const { items: tags } = useTags();

    const getTitle = (): string => {
        if (status) {
            return `${status.charAt(0).toUpperCase() + status.slice(1)} Messages`;
        }
        
        if (tagId) {
            const tag = tags.find(t => t.id === tagId);
            return tag ? `Messages tagged: ${tag.name}` : 'Messages';
        }
        
        return I18n.get(config.titles.plural);
    };

    return { title: getTitle() };
};
